<template>
    <a-drawer :visible="visible" placement="right" width="800" @close="onClose">
        <h3 class="drawer-title">
            Pand bewerken
            <a-button class="pull-right" v-on:click="onEditPropertyValuations">Waarderingen bewerken</a-button>
        </h3>
        <div
                :style="{
        right: 0,
          bottom: 0,
          width: '100%',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1,
        }"
        >
            <a-button :style="{ marginRight: '8px' }" @click="onClose">
                Annuleren
            </a-button>
            <a-button :style="{ marginRight: '8px' }" @click="updatePropertyWithJumba" v-bind:loading="loadingJumba">
                Laad Jumba gegevens in
            </a-button>
            <a-button type="primary" @click="onSubmit">
                Opslaan
            </a-button>
        </div>
        <a-form :form="form" layout="vertical">
            <a-row :gutter="16">
                <a-col :span="12">
                    <div class="ant-col ant-form-item-label"><label title="Postcode">Postcode</label></div>
                    <p>{{ propertyObject.postal_code }}</p>
                </a-col>
                <a-col :span="12">
                    <div class="ant-col ant-form-item-label"><label title="Huisnummer">Huisnummer</label></div>
                    <p>
                        {{ propertyObject.formatted_number }}
                    </p>
                </a-col>
            </a-row>
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-item label="Straat">
                        <a-input
                                v-model="propertyObject.street"
                                placeholder="Straat"
                        />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="Woonplaats">
                        <a-input
                                v-model="propertyObject.city"
                                placeholder="Woonplaats"
                        />
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-item label="Land">
                        <a-select
                                v-model="propertyObject.country_id"
                                placeholder="Selecteer een land"
                                v-on:change="onCountryChange"
                        >
                            <a-select-option v-for="country in countries" :key="country.id" :value="country.id">
                                {{ country.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="Soort">
                        <a-select
                                v-model="propertyObject.type"
                                placeholder="Kies een soort"
                        >
                            <a-select-option v-for="(typeName, type) in types" :key="type" :value="type">
                                {{ typeName }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </a-col>
            </a-row>
            <!--      <template v-if="!compact">-->
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-item label="Verhuurtype">
                        <a-select
                                v-model="propertyObject.rental_type"
                                placeholder="Selecteer een verhuurtype"
                        >
                            <a-select-option v-for="(rentalTypeName, rentalType) in rentalTypes"
                                             :key="rentalType" :value="rentalType">
                                {{ rentalTypeName }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="Onderpandtype">
                        <a-select
                                v-model="propertyObject.collateral_type"
                                placeholder="Kies een onderpandtype"
                        >
                            <a-select-option v-for="(collateralTypeName, collateralType) in collateralTypes"
                                             :key="collateralType" :value="collateralType">
                                {{ collateralTypeName }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-item label="Huurinkomsten">
                        <a-input
                                v-model="propertyObject.rental_income"
                                placeholder="Huurinkomsten"
                                prefix="€"
                                type="number"
                        />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="Heeft appartementsrecht">
                        <a-radio-group
                                button-style="solid"
                                v-model="propertyObject.has_apartment_right">
                            <a-radio-button :value="true">
                                Ja
                            </a-radio-button>
                            <a-radio-button :value="false">
                                Nee
                            </a-radio-button>
                        </a-radio-group>
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-item label="Bouwjaar">
                        <a-input
                                v-model="propertyObject.construction_year"
                                placeholder="Bouwjaar"
                                type="number"
                        />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="Woning oppervlakte">
                        <!-- This is needed because there are two fields in the properties database for woningoppervlakte -->
                        <a-input v-model="propertyObject.size"
                                 @input="propertyObject.surface = $event.target.value"
                                 addon-after="m²"
                                 placeholder="Woning oppervlakte"
                                 type="number"
                        />
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-item label="Bouwplannummer">
                        <a-input
                                v-model="propertyObject.construction_plan_number"
                                placeholder="Bouwplannummer"
                        />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="Perceeloppervlakte">
                        <a-input
                                addon-after="m²"
                                v-model="propertyObject.plot_size"
                                placeholder="Perceeloppervlakte"
                        />
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-item label="Kadestrale aanduiding">
                        <a-input
                                v-model="propertyObject.cadastral_designation"
                                placeholder="Kadestrale aanduiding"
                        />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="Kadaster object id">
                        <a-input
                                v-model="propertyObject.cadastral_number"
                                placeholder="Kadaster object id"
                        />
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-item label="Status">
                        <a-input
                                v-model="propertyObject.purpose_status"
                                placeholder="Status"
                        />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="Gebruik">
                        <a-input
                                v-model="propertyObject.purpose"
                                placeholder="Gebruik"
                        />
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-item label="Situatienummer">
                        <a-input
                                v-model="propertyObject.situation_number"
                                placeholder="Situatienummer"
                        />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="WOZ-waarde">
                        <a-input
                                v-model="propertyObject.real_estate_value"
                                placeholder="WOZ-waarde"
                                prefix="€"
                                type="number"
                        />
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-item label="Geschatte marktwaarde">
                        <a-input
                                v-model="propertyObject.market_value"
                                placeholder="Geschatte marktwaarde"
                                prefix="€"
                                type="number"
                        />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="Verkoopprijs">
                        <a-input
                                v-model="propertyObject.sale_price"
                                placeholder="Verkoopprijs"
                                prefix="€"
                                type="number"
                        />
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-item label="Verkoopkosten">
                        <a-input
                                v-model="propertyObject.sale_costs"
                                placeholder="Verkoopkosten"
                                prefix="€"
                                type="number"
                        />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="Verkoopstatus">
                        <a-input
                                v-model="propertyObject.sale_status"
                                placeholder="Verkoopstatus"
                        />
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-item label="Energielabel">
                        <a-select
                                v-model="propertyObject.energy_label"
                                placeholder="Energielabel"
                        >
                            <a-select-option v-for="(value, key) in energyLabels" :key="key" :value="key">
                                {{ value }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="Energielabel geldig tot">
                        <a-date-picker v-model="propertyObject.energy_label_end_date"
                                       :value="propertyObject.energy_label_end_date"
                                       format="DD-MM-YYYY"
                                       style="display:block;"
                                       v-on:change="setChosenDate($event,'energy_label_end_date')"
                        />
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-item label="Geschat energielabel">
                        <a-select
                                v-model="propertyObject.estimated_energy_label"
                                placeholder="Geschat energielabel"
                        >
                            <a-select-option v-for="(value, key) in energyLabels" :key="key" :value="key">
                                {{ value }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-item label="Provincie">
                        <a-auto-complete
                                v-model="propertyObject.province"
                                :data-source="provinces"
                                placeholder="Provincie"
                                :filter-option="filterOption"
                        />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="Buurt">
                        <a-input
                                v-model="propertyObject.neighborhood"
                                placeholder="Buurt"
                        >
                        </a-input>
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-item label="Gemeente">
                        <a-input
                                v-model="propertyObject.municipality"
                                placeholder="Gemeente"
                        >
                        </a-input>
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-item label="Te koop">
                        <a-radio-group
                                button-style="solid"
                                v-model="propertyObject.for_sale">
                            <a-radio-button :value="true">
                                Ja
                            </a-radio-button>
                            <a-radio-button :value="false">
                                Nee
                            </a-radio-button>
                        </a-radio-group>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="Verkocht">
                        <a-radio-group
                                button-style="solid"
                                v-model="propertyObject.sold">
                            <a-radio-button :value="true">
                                Ja
                            </a-radio-button>
                            <a-radio-button :value="false">
                                Nee
                            </a-radio-button>
                        </a-radio-group>
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-item label="Prijs">
                        <a-input
                                v-model="propertyObject.price"
                                placeholder="Prijs"
                                prefix="€"
                                type="number"
                        />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="Prijs type">
                        <a-input
                                v-model="propertyObject.price_type"
                                placeholder="Prijs type"
                        />
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-item label="Prijs soort">
                        <a-input
                                v-model="propertyObject.price_kind"
                                placeholder="Prijs soort"
                        />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="Waarde laag">
                        <a-input
                                v-model="propertyObject.value_low"
                                placeholder="Kadaster object id"
                                prefix="€"
                                type="number"
                        />
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-item label="Waarde hoog">
                        <a-input
                                v-model="propertyObject.value_high"
                                placeholder="Kadestrale aanduiding"
                                prefix="€"
                                type="number"
                        />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="Kwaliteit waarde">
                        <a-input
                                v-model="propertyObject.value_quality"
                                placeholder="Kadaster object id"
                        />
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-item label="Koopsom">
                        <a-input
                                v-model="propertyObject.purchase_price"
                                placeholder="Koopsom"
                                prefix="€"
                                type="number"
                        />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="Schuld-marktwaarde verhouding">
                        <percentage-input
                                v-model="propertyObject.debt_market_value_ratio_original"
                                placeholder="Schuld-marktwaarde verhouding"
                        />
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-item label="Afvalstoffenheffing">
                        <a-input
                                v-model="propertyObject.waste_charges"
                                placeholder="Afvalstoffenheffing"
                                prefix="€"
                                type="number"
                        />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="Rioolheffing">
                        <a-input
                                v-model="propertyObject.sewage_charges"
                                placeholder="Rioolheffing"
                                prefix="€"
                                type="number"
                        />
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-item label="Appartement type">
                        <a-input
                                v-model="propertyObject.apartment_type"
                                placeholder="Appartement type"
                        />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="Herbouwwaarde">
                        <a-input
                                v-model="propertyObject.rebuild_value"
                                placeholder="Herbouwwaarde"
                                prefix="€"
                                type="number"
                        />
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-item label="Appartement subtype">
                        <a-input
                                v-model="propertyObject.apartment_sub_type"
                                placeholder="Appartement subtype"
                        />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="Woning type">
                        <a-input
                                v-model="propertyObject.residential_building_type"
                                placeholder="Woning type"
                        />
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-item label="Woning subtype">
                        <a-input
                                v-model="propertyObject.residential_building_sub_type"
                                placeholder="Woning subtype"
                        />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="Label klasse">
                        <a-input
                                v-model="propertyObject.label_class"
                                placeholder="Label klasse"
                        />
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-item label="Label type">
                        <a-input
                                v-model="propertyObject.label_type"
                                placeholder="Label type"
                        />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="Prestatie index">
                        <a-input
                                v-model="propertyObject.performance_index"
                                placeholder="Prestatie index"
                                type="number"
                        />
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-item label="Prestatie coëfficiënt">
                        <a-input
                                v-model="propertyObject.performance_coefficient"
                                placeholder="Prestatie coëfficiënt"
                                type="number"
                        />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="Prestatie geldig tot">
                        <a-date-picker :value="propertyObject.performance_valid_until"
                                       format="DD-MM-YYYY"
                                       style="display:block;"
                                       v-on:change="setChosenDate($event,'performance_valid_until')"
                        />
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-item label="Stroom normaal">
                        <a-input
                                v-model="propertyObject.electricity_normal"
                                addon-after="m³"
                                placeholder="Stroom normaal"
                                type="number"
                        />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="Stroom dal">
                        <a-input
                                v-model="propertyObject.electricity_low"
                                addon-after="m³"
                                placeholder="Stroom dal"
                                type="number"
                        />
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-item label="Dubbele of slimme meter">
                        <a-radio-group
                                button-style="solid"
                                v-model="propertyObject.double_or_smart_meter">
                            <a-radio-button :value="true">
                                Ja
                            </a-radio-button>
                            <a-radio-button :value="false">
                                Nee
                            </a-radio-button>
                        </a-radio-group>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="Zonnepanelen">
                        <a-radio-group
                                button-style="solid"
                                v-model="propertyObject.solar_panels">
                            <a-radio-button :value="true">
                                Ja
                            </a-radio-button>
                            <a-radio-button :value="false">
                                Nee
                            </a-radio-button>
                        </a-radio-group>
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-item label="Stroomopwekking normaal">
                        <a-input
                                v-model="propertyObject.electricity_generated_normal"
                                addon-after="m³"
                                placeholder="Stroomopwekking normaal"
                                type="number"
                        />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="Stroomopwekking dal">
                        <a-input
                                v-model="propertyObject.electricity_generated_low"
                                addon-after="m³"
                                placeholder="Stroomopwekking dal"
                                type="number"
                        />
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-item label="Inhoud">
                        <a-input
                                v-model="propertyObject.dimensions_volume"
                                addon-after="m³"
                                placeholder="Inhoud"
                                type="number"
                        />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="Externe Bergruimte">
                        <a-input
                                v-model="propertyObject.dimensions_external_storage_space"
                                addon-after="m²"
                                placeholder="Externe Bergruimte"
                                type="number"
                        />
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-item label="Overige Inpandige Ruimte">
                        <a-input
                                v-model="propertyObject.dimensions_other_indoor_space"
                                placeholder="Overige Inpandige Ruimte"
                                addon-after="m²"
                                type="number"
                        />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="Gebouw Gebonden Buiten Ruimte">
                        <a-input
                                v-model="propertyObject.dimensions_building_related_outdoor_space"
                                placeholder="Gebouw Gebonden Buiten Ruimte"
                                addon-after="m²"
                                type="number"
                        />
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-item label="Dakisolatie">
                        <a-radio-group
                                button-style="solid"
                                v-model="propertyObject.isolation_roof_isolation">
                            <a-radio-button :value="true">
                                Ja
                            </a-radio-button>
                            <a-radio-button :value="false">
                                Nee
                            </a-radio-button>
                        </a-radio-group>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="Dubbel Glas">
                        <a-radio-group
                                button-style="solid"
                                v-model="propertyObject.isolation_double_glass">
                            <a-radio-button :value="true">
                                Ja
                            </a-radio-button>
                            <a-radio-button :value="false">
                                Nee
                            </a-radio-button>
                        </a-radio-group>
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-item label="Eco Bouw">
                        <a-radio-group
                                button-style="solid"
                                v-model="propertyObject.isolation_eco_build">
                            <a-radio-button :value="true">
                                Ja
                            </a-radio-button>
                            <a-radio-button :value="false">
                                Nee
                            </a-radio-button>
                        </a-radio-group>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="Gedeeltelijk Dubbel Glas">
                        <a-radio-group
                                button-style="solid"
                                v-model="propertyObject.isolation_partly_double_glass">
                            <a-radio-button :value="true">
                                Ja
                            </a-radio-button>
                            <a-radio-button :value="false">
                                Nee
                            </a-radio-button>
                        </a-radio-group>
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-item label="Geen Isolatie">
                        <a-radio-group
                                button-style="solid"
                                v-model="propertyObject.isolation_no_isolation">
                            <a-radio-button :value="true">
                                Ja
                            </a-radio-button>
                            <a-radio-button :value="false">
                                Nee
                            </a-radio-button>
                        </a-radio-group>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="Geen Spouw">
                        <a-radio-group
                                button-style="solid"
                                v-model="propertyObject.isolation_no_cavity">
                            <a-radio-button :value="true">
                                Ja
                            </a-radio-button>
                            <a-radio-button :value="false">
                                Nee
                            </a-radio-button>
                        </a-radio-group>
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-item label="Spouw">
                        <a-radio-group
                                button-style="solid"
                                v-model="propertyObject.isolation_cavity">
                            <a-radio-button :value="true">
                                Ja
                            </a-radio-button>
                            <a-radio-button :value="false">
                                Nee
                            </a-radio-button>
                        </a-radio-group>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="Muur Isolatie">
                        <a-radio-group
                                button-style="solid"
                                v-model="propertyObject.isolation_wall_isolation">
                            <a-radio-button :value="true">
                                Ja
                            </a-radio-button>
                            <a-radio-button :value="false">
                                Nee
                            </a-radio-button>
                        </a-radio-group>
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-item label="Vloer Isolatie">
                        <a-radio-group
                                button-style="solid"
                                v-model="propertyObject.isolation_floor_isolation">
                            <a-radio-button :value="true">
                                Ja
                            </a-radio-button>
                            <a-radio-button :value="false">
                                Nee
                            </a-radio-button>
                        </a-radio-group>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="Volledig Geisoleerd">
                        <a-radio-group
                                button-style="solid"
                                v-model="propertyObject.isolation_fully_isolated">
                            <a-radio-button :value="true">
                                Ja
                            </a-radio-button>
                            <a-radio-button :value="false">
                                Nee
                            </a-radio-button>
                        </a-radio-group>
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-item label="Voorzet Ramen">
                        <a-radio-group
                                button-style="solid"
                                v-model="propertyObject.isolation_secondary_windows">
                            <a-radio-button :value="true">
                                Ja
                            </a-radio-button>
                            <a-radio-button :value="false">
                                Nee
                            </a-radio-button>
                        </a-radio-group>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="Driedubbel Glas">
                        <a-radio-group
                                button-style="solid"
                                v-model="propertyObject.isolation_triple_glass">
                            <a-radio-button :value="true">
                                Ja
                            </a-radio-button>
                            <a-radio-button :value="false">
                                Nee
                            </a-radio-button>
                        </a-radio-group>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="Hr Glas">
                        <a-radio-group
                                button-style="solid"
                                v-model="propertyObject.isolation_hr_glass">
                            <a-radio-button :value="true">
                                Ja
                            </a-radio-button>
                            <a-radio-button :value="false">
                                Nee
                            </a-radio-button>
                        </a-radio-group>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="Kierdichting">
                        <a-radio-group
                                button-style="solid"
                                v-model="propertyObject.isolation_sealing">
                            <a-radio-button :value="true">
                                Ja
                            </a-radio-button>
                            <a-radio-button :value="false">
                                Nee
                            </a-radio-button>
                        </a-radio-group>
                    </a-form-item>
                </a-col>
            </a-row>
            <div style="height: 25px; "></div>
            <!--      </template>-->
        </a-form>
        <div
                :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1,
        }"
        >
            <a-button :style="{ marginRight: '8px' }" @click="onClose">
                Annuleren
            </a-button>
            <a-button type="primary" @click="onSubmit">
                Opslaan
            </a-button>
        </div>
        <PropertyEditPropertyValuationsDrawerComponent ref="editValuationsDrawer" :property="property"/>
    </a-drawer>
</template>
<script>
import countriesApi from '~/api/country';
import propertyApi from '~/api/property';
import PropertyEditComponent from './EditComponent';
import PropertyEditPropertyValuationsDrawerComponent from './EditPropertyValuationsDrawerComponent';

export default {
  name: "PropertyEditDrawerComponent",
  components: {
    PropertyEditComponent,
    PropertyEditPropertyValuationsDrawerComponent
  },
  props: {
    property: {
      type: Object,
      required: true
    },
    compact: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      propertyObject: this.property,
      countries: [],
      form: this.$form.createForm(this),
      loadingJumba: false,
      visible: false,
      types: {
        single_family_home: 'Eengezinswoning',
        single_family_house_with_garage: 'Eengezinswoning met garage',
        flat_apartment: 'Flat/appartement',
        flat_apartment_with_garage: 'Flat/appartement met garage',
        shop_house: 'Winkel-woonhuis',
        residential_house_with_commercial_space: 'Woonhuis met bedrijfsruimte',
        store: 'Winkel',
        business_premises: 'Bedrijfspand',
        recreational_home: 'Recreatiewoning',
        farm: 'Boerderij',
        business_collateral: 'Zakelijk onderpand',
        agricultural_building_land: 'Agrarische grond/bouwgrond',
        garage: 'Garage',
        building_plot: 'Bouwkavel',
        houseboat: 'Woonschip',
        pleasure_craft: 'Pleziervaartuig',
      },
      rentalTypes: {
        no_rental: 'geen verhuur',
        temporary_rental: 'tijdelijke verhuur',
        partial_temporary_rental: 'gedeeltelijke tijdelijke verhuur (kamer, etage)',
        partial_rental: 'gedeeltelijke verhuur (kamer, etage)',
        permanent_rental: 'permanente verhuur',
      },
      collateralTypes: {
        existing: 'bestaand',
        existing_renovation: 'bestaand verbouw',
        new: 'nieuw',
      },
      energyLabels: {
        EnergieNeutraal: 'EnergieNeutraal',
        NulOpDeMeter: 'NulOpDeMeter',
        'A++++': 'A++++',
        'A+++': 'A+++',
        'A++': 'A++',
        'A+': 'A+',
        A: 'A',
        B: 'B',
        C: 'C',
        D: 'D',
        E: 'E',
        F: 'F',
        G: 'G',
      },
      provinces: [
        'Drenthe',
        'Friesland',
        'Flevoland',
        'Gelderland',
        'Groningen',
        'Limburg',
        'Noord-Brabant',
        'Noord-Holland',
        'Overijssel',
        'Utrecht',
        'Zeeland',
        'Zuid-Holland'
      ]
    };
  },
  mounted() {
    countriesApi.all().then(response => {
      this.countries = response.data;
    })
  },
  methods: {
    setChosenDate(moment, key) {
      this.propertyObject[key] = moment.format()
    },
    showDrawer() {
      this.visible = true;
    },
    onSubmit() {
      propertyApi.update(this.propertyObject).then(() => {
        this.visible = false;
        this.$emit('updated', this.propertyObject)
      }).catch(error => {
        this.$message.error('Er ging iets mis tijdens het bijwerken van het pand');
      });
    },
    onClose() {
      this.visible = false;
    },
    updatePropertyWithJumba() {
      if (this.propertyObject !== null) {
        this.loadingJumba = true;

        propertyApi.updateWithJumba(this.propertyObject)
          .then(response => {
            this.propertyObject = response.data;
            this.$emit('updated', this.propertyObject)
          })
          .finally(() => {
            this.loadingJumba = false;
          })
      }
    },
    onCountryChange() {
      this.$set(this.propertyObject, 'country', {
        data: this.countries.find(country => country.id === this.propertyObject.country_id)
      });
    },
    onEditPropertyValuations() {
      this.$refs.editValuationsDrawer.visible = true;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toUpperCase().indexOf(input.toUpperCase()) >= 0
      );
    },
  },
};
</script>
<style scoped>
.drawer-title {
    margin-bottom: 30px;
}

.pull-right {
    float: right;
}
</style>